import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-content" }
const _hoisted_2 = { class: "tab-pane" }

import contentWithImage from '@/components/web/contentWithImage.vue'
import advantage from '@/components/web/advantage.vue';
import imageTableTitle from '@/components/web/imageTableTitle.vue';
import headText from '@/components/web/headText.vue';
import viewHomeService from '@/components/web/content/viewHomeService.vue';
import { ref } from 'vue';

const fontSize = "1.25rem";
const fontWeight = 500;
const h2Color = "#0c2e60";

//advantage
const h2Adv = "Our Parts Manufacturing Advance Capability";
const pAdv = "Our molds are processed independently, without additional profit, moderate cost, short cycle, and sample out at the fastest 20 days, and all our company's ex-factory die-casting parts and unqualified products are returned and exchanged unconditionally without reason.";
const imgHeight = "108px";
const imgWidth = "100px";

const productTitle = "Other Die Casting Parts And Machining Products";



export default /*@__PURE__*/_defineComponent({
  __name: 'ContentProduct',
  props: {
    contentWithImg: { default: () => ({
            h2Title: '',
            pList: [],
            img: []
        }) },
    productCollection: {},
    advantageProps: { default: () => (
            {
                h2Title: "Our Parts Manufacturing Advance Capability",
                pTitle: "Our molds are processed independently, without additional profit, moderate cost, short cycle, and sample out at the fastest 20 days, and all our company's ex-factory die-casting parts and unqualified products are returned and exchanged unconditionally without reason."
            }
        ) },
    advantageCollection: {},
    viewadvantageCollection: {},
    viewPartsCollection: {},
    honorCertificatesCollection: {},
    dieCastingWorkshopCollection: {}
  },
  setup(__props: any) {

const props = __props;




//组件传输数据
//contentWithImage
const imageList = ref<imageAltItem[]>([])

imageList.value = [
    {
        imgUrl: 'https://www.diecastingcompany.com/uploads/2102/die-casting-customized-low-power-led-lamp-cup-aluminium-die-casting-products.jpg',
        alt: 'die-casting-Customized-Low-Power-LED-Lamp-Cup-Aluminium-Die-Casting-Products'
    }
];

const defaultAdvantage = ref<advantageType>

//headText
const h2pLContent = ref<h2pLContentType>([]);
h2pLContent.value = [
    {
        pList: [
        ],
        liList: [
            "High-precision aluminum alloy die castings, with a controllable tolerance of +-0.1mm.",
            "Brand new die-casting machine, aluminum alloy die-casting parts can be controlled without sand holes, no water marks, no blistering, no pitting, no rust, no oxidation.",
            "The density of the die casting product is uniform, the product is not easy to break, deform, and the quality is stable.",
            "The factory does not shut down 24 hours a day, your delivery time and quality are our mission."
        ]
    }
]

//viewHomeService

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<ul class=\"nav nav-tabs\" data-v-56161b9b><li class=\"nav-item\" data-v-56161b9b><a class=\"nav-link active\" data-toggle=\"tab\" href=\"#product-content\" data-v-56161b9b>Description</a></li><li class=\"nav-item\" data-v-56161b9b><a class=\"nav-link\" href=\"/data-download\" target=\"_blank\" data-v-56161b9b>Downloads</a></li><li class=\"nav-item\" data-v-56161b9b><a class=\"nav-link\" href=\"/faq\" target=\"_blank\" data-v-56161b9b>Product Questions</a></li><li class=\"nav-item\" data-v-56161b9b><a class=\"nav-link\" href=\"/die-casting-video\" target=\"_blank\" data-v-56161b9b>Manufacturing Video</a></li><li class=\"nav-item\" data-v-56161b9b><a class=\"nav-link\" href=\"/case-studies\" target=\"_blank\" data-v-56161b9b>Product Gallery</a></li></ul>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(contentWithImage, {
        h2Title: _ctx.contentWithImg.h2Title,
        pList: _ctx.contentWithImg.pList,
        imageList: _ctx.contentWithImg.img,
        hasTailHr: true,
        "font-size": fontSize,
        "font-weight": fontWeight,
        "title-color": h2Color
      }, null, 8, ["h2Title", "pList", "imageList"]),
      _createVNode(viewHomeService, {
        "honor-certificates-collection": _ctx.honorCertificatesCollection,
        "die-casting-workshop-collection": _ctx.dieCastingWorkshopCollection,
        productCollection: _ctx.productCollection
      }, null, 8, ["honor-certificates-collection", "die-casting-workshop-collection", "productCollection"])
    ])
  ]))
}
}

})